import { Link } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import { whatsappLink, PHONE_DISPLAY } from "../i18n/translations";
import logo from "../assets/img/logo.png";

export const Footer = () => {
  const { t, lang } = useLanguage();
  const year = new Date().getFullYear();

  const bookOchnoMsg =
    lang === "ru"
      ? "Здравствуйте! Хочу записаться на очное занятие."
      : "Hello! I'd like to book an in-person class.";
  const bookOnlineMsg =
    lang === "ru"
      ? "Здравствуйте! Хочу узнать больше об онлайн-тренировках."
      : "Hello! I'd like to learn more about online training.";

  return (
    <footer className="site-footer">
      <div className="site-footer-inner">
        <div className="footer-col footer-brand">
          <img src={logo} alt="Sport with Natalia" />
          <p>{t.footer.tagline}</p>
          <p className="footer-phone">{PHONE_DISPLAY}</p>
        </div>
        <div className="footer-col footer-links">
          <Link to="/o-trenere">{t.nav.about}</Link>
          <Link to="/korporativ">{t.nav.corporate}</Link>
        </div>
        <div className="footer-col footer-ctas">
          <a className="footer-cta" href={whatsappLink(bookOchnoMsg)} target="_blank" rel="noreferrer">
            {t.footer.bookOchno} →
          </a>
          <a className="footer-cta" href={whatsappLink(bookOnlineMsg)} target="_blank" rel="noreferrer">
            {t.footer.bookOnline} →
          </a>
        </div>
      </div>
      <div className="footer-bottom">
        © {year} Sport with Natalia. {t.footer.rights}
      </div>
    </footer>
  );
};
